const autoNgTemplateLoaderTemplate1 = require('./storidgeSnapshotCreation.html');

angular.module('portainer.docker').component('storidgeSnapshotCreation', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'StoridgeSnapshotCreationController',
  bindings: {
    volumeId: '<',
  },
});
